import { render, staticRenderFns } from "./DistributionReservationSidebar.vue?vue&type=template&id=61f8f792&scoped=true&"
import script from "./DistributionReservationSidebar.vue?vue&type=script&lang=js&"
export * from "./DistributionReservationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8f792",
  null
  
)

export default component.exports